module.exports = __webpack_public_path__ + "img/69.4e205b1a.jpg";